import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Form,
    Modal,
    Typography,
    Button,
    Input,
    notification,
} from "antd";
import RuntimeConfigsApi from "../../Apis/RuntimeConfigsApi";
import axios from "axios";

const { Title } = Typography;
function AddSensorApiConfigurations({ visible, onClose }) {
    const [formAdd] = Form.useForm();
    const navigate = useNavigate
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const handleSubmit = (data) => {
        let formData = JSON.stringify({
            configType: "SENSOR_API_CONFIG",
            runtimeConfigList: [{
                configKey: "USER_NAME",
                configValue: data?.user_name
            },
            {
                configKey: "PASSWORD",
                configValue: data?.password
            },
            {
                configKey: "PROVIDER",
                configValue: data?.provider
            }],
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        })
        let url = `https://api.sync-sign.com/v2/oauth/token`;

        axios
            .post(url, {
                "username": data?.user_name,
                "password": data?.password,
                "provider": data?.provider
            })
            .then((res) => {
                localStorage.setItem("SensorApi", res?.data?.data?.accessToken);
                RuntimeConfigsApi.CreateRuntimeConfigs(formData)
                    .then((response) => {
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                            description: "Update Successfully",
                            closeIcon: false,
                            duration: 3,
                            style: {
                                backgroundColor: "#b3ffb3",
                                color: "green",
                            },
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    })
                    .catch((err) => {
                        if (err.apiError.status) {
                            notification.open({
                                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                                description: err.apiError.message,
                                closeIcon: false,
                                duration: 3,
                                style: {
                                    backgroundColor: "#fff2f0",
                                    color: "red",
                                },
                            });
                        }
                    });
            })
            .catch((err) => {
                console.log(err);
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Error</span>,
                    description: "Invalid User",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
            });


    }


    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    const validateInputNumber = (_, value) => {
        if (value >= 0) {
            return Promise.resolve();
        }
        return Promise.reject(new Error("Value must be greater than to 0"));
    };

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Set Default Mocreo Settings
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <> <Form.Item
                        name="user_name"
                        label="User Name "
                        className="text-lable "
                        rules={[
                            {
                                required: true,
                                message: "Please Enter User Name ",
                            },
                        ]}
                    >
                        <Input
                            type="text"
                            className="control-input"
                        />
                    </Form.Item>
                        <Form.Item
                            name="password"
                            label="Password "
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Password ",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="provider"
                            label="Provider"
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Provider",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                className="control-input"
                            />
                        </Form.Item>


                        <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Save
                            </Button>

                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddSensorApiConfigurations;
